import { app } from '../../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.sharing-center.shared-folders.manage.edit', {
        url: '/edit',
        component: 'companySharingCenterSharedFoldersManageEdit',
    });
}




// WEBPACK FOOTER //
// ./src/portal/states/company/sharing-center/shared-folders/manage/edit/edit-shared-folder.state.js